import { render, staticRenderFns } from "./PartnerProfile.vue?vue&type=template&id=15e32fcc&"
import script from "./PartnerProfile.vue?vue&type=script&lang=js&"
export * from "./PartnerProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports